export const locales = ['en', 'he'] as const;
export const defaultLocale = 'en';
export const rtlLocales = ['he'];
export type Locale = typeof locales[number];

export function isRtl(l: Locale) {
  return (rtlLocales as readonly string[]).includes(l);
}
